export default "__VITE_ASSET__CGAMaDbW__"